// extracted by mini-css-extract-plugin
export default {"error_container":"ivasErrors_error_container__H3VSE","header":"ivasErrors_header__fASh9","line_break":"ivasErrors_line_break__vqmam"};